import Component from '@glimmer/component';
import { getHours, getMinutes, parse } from 'date-fns';

interface DropdownOptionSignature {
  Args: {
    closestTime?: Date;
    value: string;
  };
  Element: HTMLOptionElement;
}

export default class DropdownOption extends Component<DropdownOptionSignature> {
  get isClosest(): boolean {
    const { value, closestTime } = this.args;
    if (!closestTime) return false;
    const parsed = parse(value, 'h:mm a', new Date(0));
    return getHours(parsed) === getHours(closestTime) && getMinutes(parsed) === getMinutes(closestTime);
  }

  <template>
    <option selected={{this.isClosest}} ...attributes>{{@value}}</option>
  </template>
}
